import React, { useMemo } from "react";
import { cn } from "utils";
import { ProductPayCycle } from "../../Member/CurrentPlan/constants";
import { PaymentDetailsProps } from "./types";
import Translations from "@translate/components/Payment/PaymentContent/PaymentDetails";
import { I18nUtil } from "@utils/i18n";
import { MemberProduct } from "@/src/features/api/memberApi";

const I18n = I18nUtil.createScoped(Translations);

export const PaymentDetails: React.FC<PaymentDetailsProps> = ({
  amount,
  isTrial,
  plan,
  planId,
  data,
}) => {
  // 获取试用期后的价格，通过planId获取到整个数据，然后通过数据获取类型，通过类型判断用户当前购买的是否为试用产品
  const currentPlan = data?.find((item: MemberProduct) => item.id === planId);
  const type =
    currentPlan?.pay_cycle === ProductPayCycle.MONTH ? "month" : "year";
  const title = useMemo(() => {
    if (isTrial) {
      return I18n.t("Edgen %{var0} 7-Day Subscription", {
        var0: plan?.name,
      });
    }
    return `${
      type === "year"
        ? I18n.t("Edgen %{var0} Yearly Subscription", {
            var0: plan?.name,
          })
        : I18n.t("Edgen %{var0} Month Subscription", {
            var0: plan?.name,
          })
    }`;
  }, [type, plan?.name, isTrial]);

  return (
    <div className="flex flex-col w-full">
      <div
        className={cn("flex flex-col md:items-start items-center gap-1 w-full")}
      >
        <div className="md:body_m body_s text-content_secondary whitespace-nowrap">
          {title}
        </div>
        <div className="md:display_s headline_regular_l text-content_primary">
          {amount}
        </div>
      </div>
    </div>
  );
};
